export const CommonModelFamiliesValues = ['q5', 'a5', 'q4', 'q6etron', 'q7'];
